export default __webpack_public_path__ + "static/media/syndi.434201e2.png";